import { getActivityFeedStore } from './store';

export function getPromptFeedAction() {
    return getActivityFeedStore().feedAction.promptFeedAction;
}

export function getFeedActionType() {
    return getActivityFeedStore().feedAction.type;
}

export function getFeedActionCallback() {
    return getActivityFeedStore().feedAction.feedActionCallback;
}
